<template>
  <div class="dashboard" dir="rtl">
    <header class="header">
      <h1>لوحة الأحصائيات</h1>
      <div class="date-time">{{ currentDateTime }}</div>
    </header>

    <div class="sent-notification">
  <button class="btn btn-primary" @click="openNotificationModal">
    📢 إرسال إشعار
  </button>
</div>


    <div class="dashboard-content">
      <div class="stats-container">
        <div class="stats-grid">
          <div class="stat-card highlight">
            <div class="stat-icon">📚</div>
            <div class="stat-info">
              <h3>إجمالي الكورسات</h3>
              <p>{{ dashboardData.totalCourses }}</p>
            </div>
          </div>
          <div class="stat-card highlight">
            <div class="stat-icon">👥</div>
            <div class="stat-info">
              <h3>إجمالي المستخدمين</h3>
              <p>{{ dashboardData.totalUsers }}</p>
            </div>
          </div>
          <div class="stat-card highlight">
            <div class="stat-icon">🏛️</div>
            <div class="stat-info">
              <h3>إجمالي الجامعات</h3>
              <p>{{ dashboardData.totalUniversities }}</p>
            </div>
          </div>
          <div class="stat-card highlight">
            <div class="stat-icon">🎫</div>
            <div class="stat-info">
              <h3>إجمالي الكوبونات</h3>
              <p>{{ dashboardData.totalCoupons }}</p>
            </div>
          </div>
          <div class="stat-card highlight">
            <div class="stat-icon">✅</div>
            <div class="stat-info">
              <h3>الكوبونات النشطة</h3>
              <p>{{ dashboardData.totalActiveCoupons }}</p>
            </div>
          </div>
          <div class="stat-card highlight">
            <div class="stat-icon">🔄</div>
            <div class="stat-info">
              <h3>الكوبونات المستخدمة</h3>
              <p>{{ dashboardData.totalUsedCoupons }}</p>
            </div>
          </div>
          <div class="stat-card highlight">
            <div class="stat-icon">💰</div>
            <div class="stat-info">
              <h3>إجمالي المبيعات</h3>
              <p>{{ dashboardData.totalSales }}</p>
            </div>
          </div>
        </div>
      </div>

      <div class="news-section">
        <div class="news-slider" ref="slider">
          <transition-group name="fade">
            <div
              v-for="(item, index) in sliderItems"
              :key="index"
              v-show="currentSlide === index"
              class="slider-item"
            >
              <img :src="item.imageFullUrl" :alt="'صورة ' + (index + 1)" />
              <div class="slider-overlay"></div>
            </div>
          </transition-group>
          <div class="slider-controls">
            <div class="slider-dots">
              <span
                v-for="(_, index) in sliderItems"
                :key="index"
                :class="['dot', { active: currentSlide === index }]"
                @click="setSlide(index)"
              >
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- sent notificion model -->
  <transition name="modal">
    <div v-if="notificationModel" class="modal-overlay" @click.self="closeModal">
      <div class="modal-content">
        <div class="modal-header">
          <h2 class="modal-title">إرسال إشعار</h2>
          <button class="close" @click="notificationModel = false">X</button>
        </div>
        <div class="modal-body">
          <form @submit.prevent="sendNotification">
            <div class="form-group">
              <label for="title">العنوان</label>
              <input v-model="notifictionForm.subject" type="text" class="form-control" id="title" placeholder="أدخل عنوان الإشعار" />
            </div>
            <div class="form-group">
              <label for="title">رابط الصورة</label>
              <input v-model="notifictionForm.image" type="text" class="form-control" id="title" placeholder="أدخل عنوان الإشعار" />
            </div>
            <div class="form-group">
              <label for="message">الرسالة</label>
              <textarea v-model="notifictionForm.message" class="form-control" id="message" rows="3" placeholder="أدخل نص الإشعار"></textarea>
            </div>
            <button type="submit" class="btn btn-primary">إرسال</button>
          </form>
        </div>
      </div>
    </div>
  </transition>

</template>

<script>
import apiClient from "@/api";
import Swal from "sweetalert2";

export default {
  name: "DashboardPage",
  data() {
    return {
      dashboardData: {
        totalCourses: 0,
        totalUsers: 0,
        totalUniversities: 0,
        totalCoupons: 0,
        totalActiveCoupons: 0,
        totalUsedCoupons: 0,
        totalSales: 0,
      },
      sliderItems: [],
      loading: true,
      currentSlide: 0,
      currentDateTime: "",
      slideInterval: null,
      notificationModel: false,
      notifictionForm : {
        subject: "",
        message: "",
        image: ""
      }
    };
  },
  methods: {

    closeModal() {
      this.notificationModel = false;
    },

    openNotificationModal() {
      this.notificationModel = true;
    },
   
    async sendNotification() {
  try {
    // استدعاء API
    await apiClient.post(
      `/api/News/Send-notification`,
      this.notificationForm, // تأكد من أن اسم المتغير صحيح
  
    );

    // عرض رسالة نجاح
    this.showSuccess("تم إرسال الإشعار بنجاح");  
  } catch (error) {
    // عرض رسالة خطأ في حال فشل الطلب
    this.showError("حدث خطأ أثناء إرسال الإشعار، يرجى المحاولة مجددًا");
    console.error("خطأ في إرسال الإشعار:", error);
  }
},

showSuccess(message) {
  Swal.fire({
    icon: "success",
    title: "تم",
    text: message,
    timer: 2000,
    showConfirmButton: false,
  });
},

showError(message) {
  Swal.fire({
    icon: "error",
    title: "خطأ",
    text: message,
    timer: 2000,
    showConfirmButton: false,
  });
},
    setSlide(index) {
      this.currentSlide = index;
    },
    nextSlide() {
      this.currentSlide = (this.currentSlide + 1) % this.sliderItems.length;
    },
    startSlideShow() {
      this.slideInterval = setInterval(this.nextSlide, 4000);
    },
    updateDateTime() {
      const now = new Date();
      const options = {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      };
      this.currentDateTime = new Intl.DateTimeFormat("ar-SA", options).format(
        now
      );
    },
  },
  async created() {
    try {
      const [dashboardResponse, sliderResponse] = await Promise.all([
        apiClient.get("/api/Dashbord/GetDashboardCounts"),
        apiClient.get("/api/Slider/GetAllSliders", {
          params: {
            PageNumber: 1,
            PageSize: 10,
          },
        }),
      ]);

      this.dashboardData = dashboardResponse.data.data;
      this.sliderItems = sliderResponse.data.items;

      this.startSlideShow();
      this.updateDateTime();
      setInterval(this.updateDateTime, 60000);
    } catch (error) {
      console.error("حدث خطأ أثناء جلب البيانات:", error);
    } finally {
      this.loading = false;
    }
  },
};
</script>

<style scoped>

.sent-notification {
  display: flex;
  justify-content: center;
  margin: 20px 0;
}

.sent-notification .btn {
  background-color: #007bff;
  color: white;
  font-size: 18px;
  padding: 12px 20px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.2s ease;
  display: flex;
  align-items: center;
  gap: 8px;
}

.sent-notification .btn:hover {
  background-color: #0056b3;
  transform: scale(1.05);
}

.sent-notification .btn:active {
  transform: scale(0.98);
}



.dashboard {
  min-height: 100vh;
  background-color: #e6ecf2;
}

.header {
  background-color: #012f49;
  color: #fff;
  padding: 0.85rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 2px 4px rgba(1, 47, 73, 0.1);
}

.header h1 {
  margin: 0;
  font-size: 1.8rem;
  color: #ffc007;
}

.date-time {
  font-size: 1rem;
  color: #ffc007;
}

.dashboard-content {
  padding: 2rem;
}

/* تصميم الإحصائيات */
.stats-container {
  margin-bottom: 3rem;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1.5rem;
}

.stat-card {
  background: #fff;
  border-radius: 15px;
  padding: 1.5rem;
  display: flex;
  align-items: center;
  box-shadow: 0 4px 6px rgba(1, 47, 73, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.stat-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 6px 12px rgba(1, 47, 73, 0.15);
}

.stat-icon {
  font-size: 1.5rem;
  margin-left: 1rem;
}

.stat-info h3 {
  color: #012f49;
  margin: 0 0 0.5rem 0;
  font-size: 1rem;
}

.stat-info p {
  color: #ffc007;
  font-size: 1.5rem;
  font-weight: bold;
  margin: 0;
}

.highlight {
  background: linear-gradient(135deg, #012f49, #014c73);
}

.highlight .stat-info h3,
.highlight .stat-info p {
  color: #ffc007;
}

/* تصميم قسم الأخبار */
.news-section {
  background: #ffc007;
  border-radius: 15px;
  padding: 0.5rem;
  box-shadow: 0 4px 6px rgba(1, 47, 73, 0.1);
}

.news-section h2 {
  color: #012f49;
  margin-bottom: 1.5rem;
  font-size: 1.5rem;
}

.news-slider {
  position: relative;
  width: 100%;
  height: 500px;
  border-radius: 10px;
  overflow: hidden;
}

.slider-item {
  position: absolute;
  width: 100%;
  height: 100%;
}

.slider-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.slider-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(transparent, rgba(1, 47, 73, 0.9));
  padding: 2rem;
  color: #fff;
}

.slider-overlay h3 {
  color: #ffc007;
  margin: 0 0 0.5rem 0;
  font-size: 1.5rem;
}

.slider-overlay p {
  margin: 0;
  font-size: 1rem;
}

.slider-controls {
  position: absolute;
  bottom: 1rem;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
}

.slider-dots {
  display: flex;
  gap: 0.5rem;
}

.dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.5);
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.dot.active {
  background: #ffc007;
}

/* حالة التحميل */
.loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
}

.spinner {
  width: 50px;
  height: 50px;
  border: 4px solid #ffc007;
  border-top: 4px solid #012f49;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 1rem;
}

.modal-overlay {
  direction: rtl;
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 50;
  backdrop-filter: blur(4px);
}

.modal-overlay {

  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}
.modal-content {
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  width: 400px;
  max-width: 90%;
}
.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.close {
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
}


@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* انيميشن التبديل بين الشرائح */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
